import React from 'react';
import { Link } from 'react-router-dom';
import { Linkedin, Facebook, Twitter, Instagram, Mail } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-[#2C2C2C] text-white py-12 sm:py-16 px-4 sm:px-6">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 sm:gap-12 mb-12">
          {/* Brand */}
          <div className="col-span-2 md:col-span-1">
            <h3 className="font-heading text-xl sm:text-2xl mb-4">The Lady Hustler Society Club</h3>
            <p className="font-body text-white/60 text-sm mb-6">
              A global community of women entrepreneurs and professionals building with resourcefulness, courage, and collective intelligence.
            </p>
            <div className="flex gap-3">
              <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer" className="w-9 h-9 border border-white/20 flex items-center justify-center text-white/60 hover:text-white hover:border-white/40 transition-colors">
                <Linkedin className="w-4 h-4" />
              </a>
              <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" className="w-9 h-9 border border-white/20 flex items-center justify-center text-white/60 hover:text-white hover:border-white/40 transition-colors">
                <Facebook className="w-4 h-4" />
              </a>
              <a href="https://twitter.com" target="_blank" rel="noopener noreferrer" className="w-9 h-9 border border-white/20 flex items-center justify-center text-white/60 hover:text-white hover:border-white/40 transition-colors">
                <Twitter className="w-4 h-4" />
              </a>
              <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" className="w-9 h-9 border border-white/20 flex items-center justify-center text-white/60 hover:text-white hover:border-white/40 transition-colors">
                <Instagram className="w-4 h-4" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-label text-xs tracking-widest text-white/40 mb-4">QUICK LINKS</h4>
            <ul className="space-y-3">
              <li><a href="https://entrepreneurladyhustler.com/en/blog/" className="font-body text-sm text-white/60 hover:text-white transition-colors">The Journal</a></li>
              <li><a href="https://join.entrepreneurladyhustler.com" target="_blank" rel="noopener noreferrer" className="font-body text-sm text-white/60 hover:text-white transition-colors">Membership</a></li>
              <li><a href="https://societe.entrepreneurladyhustler.com" target="_blank" rel="noopener noreferrer" className="font-body text-sm text-white/60 hover:text-white transition-colors">The Société</a></li>
              <li><a href="https://entrepreneurladyhustler.com/en/get-involved-the-lady-hustler-society-club/" target="_blank" rel="noopener noreferrer" className="font-body text-sm text-white/60 hover:text-white transition-colors">Get Involved</a></li>
              <li><a href="https://entrepreneurladyhustler.com/en/leadership/" target="_blank" rel="noopener noreferrer" className="font-body text-sm text-white/60 hover:text-white transition-colors">About LHSC</a></li>
            </ul>
          </div>

          {/* Member Login */}
          <div>
            <h4 className="font-label text-xs tracking-widest text-white/40 mb-4">MEMBER LOGIN</h4>
            <ul className="space-y-3">
              <li><a href="https://app.entrepreneurladyhustler.com/login" target="_blank" rel="noopener noreferrer" className="font-body text-sm text-white/60 hover:text-white transition-colors">Membership Login</a></li>
              <li><a href="https://theladyhustlersocietyclub.app.clientclub.net/login" target="_blank" rel="noopener noreferrer" className="font-body text-sm text-white/60 hover:text-white transition-colors">The Société Login</a></li>
            </ul>
          </div>

          {/* Resources */}
          <div>
            <h4 className="font-label text-xs tracking-widest text-white/40 mb-4">RESOURCES</h4>
            <ul className="space-y-3">
              <li><Link to="/en/blog?category=entrepreneurship" className="font-body text-sm text-white/60 hover:text-white transition-colors">Entrepreneurship</Link></li>
              <li><Link to="/en/blog?category=tools-systems" className="font-body text-sm text-white/60 hover:text-white transition-colors">Tools & Systems</Link></li>
              <li><Link to="/en/blog?category=leadership" className="font-body text-sm text-white/60 hover:text-white transition-colors">Leadership</Link></li>
              <li><Link to="/en/blog/women-who-changed-the-rules" className="font-body text-sm text-white/60 hover:text-white transition-colors">Women Who Changed the Rules</Link></li>
              <li><Link to="/en/blog?category=global-impact" className="font-body text-sm text-white/60 hover:text-white transition-colors">Global Impact</Link></li>
            </ul>
          </div>

          {/* Contact */}
          <div className="col-span-2 md:col-span-1">
            <h4 className="font-label text-xs tracking-widest text-white/40 mb-4">CONTACT</h4>
            <ul className="space-y-3">
              <li className="flex items-center gap-2 text-white/60">
                <Mail className="w-4 h-4 flex-shrink-0" />
                <a href="mailto:hello@entrepreneurladyhustler.com" className="font-body text-sm hover:text-white transition-colors break-all">
                  hello@entrepreneurladyhustler.com
                </a>
              </li>
              <li className="font-body text-sm text-white/60 mt-4">
                Montreal, Canada<br />
                Operating Globally
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-white/10 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="font-body text-xs text-white/40">
            © 2026 The Lady Hustler Society Club. All rights reserved.
          </p>
          <div className="flex gap-6">
            <a href="/en/privacy/" className="font-body text-xs text-white/40 hover:text-white transition-colors">Privacy Policy</a>
            <a href="/en/terms/" className="font-body text-xs text-white/40 hover:text-white transition-colors">Terms of Service</a>
            <Link to="/admin" className="font-body text-xs text-white/40 hover:text-white transition-colors">Admin</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
